// import moment from 'moment';

export const OverrideBool = Object.freeze({
  True: 0,
  False: 1,
  None: 2
});

export const uniqueArray = (array) => {
  return array.filter((value, index, self) => {
    return self.indexOf(value) === index;
  });
}

// Standard easing function: t is between 0 and 1
export function easeInOutCubic(t) {
  return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
}

// % is the remainder operator in javascript so need this function
// to handle modulo for negative numbers
export function mod(num, m) {
  const remain = num % m;
  return remain >= 0 ? remain : remain + m;
}

export function stringifyPGDate(date) {

  if(typeof(date) === "string") {
    date = new Date(date);
  }

  let day = date.getDate();
  let month = date.getMonth() + 1;
  const year = date.getFullYear();

  if(day < 10) {
    day = "0" + day;
  }

  if(month < 10) {
    month = "0" + month;
  }

  // sentinal value for obscure bug with invalid dates
  if(month > 12 || day > 31) {
    return 'failed'; 
  }

  return `${year}-${month}-${day}`;
}

export function roundThis(num) {
  if (typeof num !== 'number') {
    const error = 'roundThis function param not a number';
    console.error(error);
    throw error;
  } else return Number((Math.round(num * 100) / 100).toFixed(2));
}